import {Icon, IconType} from "@client/components/Icon";
import * as typography from "@client/shared/typography";
import {layoutStyles} from "@client/site/Layout";
import * as style from "@client/style";
import {classNames, reverse} from "@reactivated";
import React from "react";

export {Layout} from "@client/site/Layout";

export const Register = (props: {isSubmitting: boolean}) => (
    <div className={layoutStyles.register}>
        <typography.Button submit disabled={props.isSubmitting}>
            Register
        </typography.Button>
        <typography.P small muted>
            By creating your account, you agree to our{" "}
            <typography.A href={reverse("terms_of_service")}>
                terms of service
            </typography.A>
            .
        </typography.P>
    </div>
);

const highlightColors = {
    orange: {foreground: style.colors.brand, background: "rgb(251,224,217)"},
    blue: {foreground: "#73C7E6", background: "rgb(223,242,249)"},
    green: {foreground: "#50BD9C", background: "rgb(191,231,219)"},
    stone: {foreground: "#488EA5", background: "rgb(171,207,219)"},
    teal: {foreground: "#50BD9C", background: "#414C5B"},
    purple: {foreground: "#7867c1", background: "#e7e4f4"},
} as const;

interface HighlightProps {
    title: string;
    icon: IconType;
    description: React.ReactNode;
    variant: keyof typeof highlightColors;
    children: React.ReactNode;
    border?: true;
    large?: boolean;
}

export const Highlight = ({
    variant,
    icon,
    title,
    description,
    children,
    border,
    large,
}: HighlightProps) => (
    <div
        className={classNames(
            layoutStyles.highlight,
            border === true && layoutStyles.highlightBorder,
        )}
        style={
            {
                "--color": highlightColors[variant].foreground,
                "--light-color": highlightColors[variant].background,
                "--text-size": large === true ? "16px" : "14px",
                "--header-size": large === true ? "24px" : "16px",
            } as React.CSSProperties
        }
    >
        <Icon large="relative" icon={icon}>
            <h3>{title}</h3>
            <p>{description}</p>
            <ul>{children}</ul>
        </Icon>
    </div>
);

export function Spinner() {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            className="text-white"
        >
            <g>
                <rect x="11" y="1" width="2" height="5" opacity=".4" />
                <rect
                    x="11"
                    y="1"
                    width="2"
                    height="5"
                    transform="rotate(30 12 12)"
                    opacity=".5"
                />
                <rect
                    x="11"
                    y="1"
                    width="2"
                    height="5"
                    transform="rotate(60 12 12)"
                    opacity=".6"
                />
                <rect
                    x="11"
                    y="1"
                    width="2"
                    height="5"
                    transform="rotate(90 12 12)"
                    opacity=".7"
                />
                <rect
                    x="11"
                    y="1"
                    width="2"
                    height="5"
                    transform="rotate(120 12 12)"
                    opacity=".8"
                />
                <rect
                    x="11"
                    y="1"
                    width="2"
                    height="5"
                    transform="rotate(150 12 12)"
                    opacity=".9"
                />
                <rect x="11" y="1" width="2" height="5" transform="rotate(180 12 12)" />
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    calcMode="discrete"
                    dur="0.75s"
                    values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
                    repeatCount="indefinite"
                />
            </g>
        </svg>
    );
}
